export default "__VITE_ASSET__DZdgW9UP__"